import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const ApplePayIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148973)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="#818891"
        />
        <path
          d="M9.45902 13.1345C9.21146 13.4318 8.81542 13.6662 8.41938 13.6327C8.36986 13.2308 8.56378 12.8038 8.79066 12.54C9.03822 12.2344 9.47138 12.0168 9.82206 12C9.8633 12.4186 9.70242 12.8289 9.45902 13.1345ZM9.8179 13.7123C9.24446 13.6788 8.75354 14.043 8.48126 14.043C8.20486 14.043 7.78818 13.729 7.33438 13.7374C6.74446 13.7458 6.19574 14.0849 5.89458 14.6249C5.27578 15.705 5.7337 17.3043 6.3319 18.1834C6.62482 18.6188 6.97546 19.0961 7.43754 19.0794C7.87482 19.0626 8.0481 18.7905 8.57614 18.7905C9.10834 18.7905 9.26098 19.0794 9.72302 19.071C10.2016 19.0626 10.5027 18.6356 10.7957 18.2002C11.1298 17.7062 11.266 17.2247 11.2742 17.1996C11.266 17.1912 10.3501 16.8354 10.3419 15.7636C10.3336 14.8678 11.0638 14.4407 11.0968 14.4156C10.6843 13.796 10.0407 13.729 9.8179 13.7123ZM13.1307 12.4982V19.0249H14.129V16.7935H15.5111C16.7735 16.7935 17.6605 15.9144 17.6605 14.6417C17.6605 13.369 16.79 12.4982 15.5441 12.4982H13.1307ZM14.129 13.3522H15.2801C16.1464 13.3522 16.6415 13.8211 16.6415 14.6459C16.6415 15.4706 16.1464 15.9437 15.2759 15.9437H14.129V13.3522ZM19.4839 19.0752C20.111 19.0752 20.6927 18.7528 20.9567 18.242H20.9773V19.0249H21.9014V15.7762C21.9014 14.8342 21.1589 14.2272 20.0161 14.2272C18.9559 14.2272 18.172 14.8426 18.1431 15.6883H19.0425C19.1167 15.2864 19.4839 15.0226 19.9872 15.0226C20.5978 15.0226 20.9402 15.3115 20.9402 15.8432V16.2032L19.6943 16.2786C18.5351 16.3498 17.908 16.8312 17.908 17.6685C17.908 18.5142 18.5557 19.0752 19.4839 19.0752ZM19.7521 18.3007C19.2199 18.3007 18.8816 18.0411 18.8816 17.6434C18.8816 17.2331 19.2075 16.9945 19.8305 16.9568L20.9402 16.8856V17.254C20.9402 17.8653 20.4286 18.3007 19.7521 18.3007ZM23.1349 20.8C24.1085 20.8 24.5665 20.4232 24.9667 19.2803L26.72 14.29H25.7051L24.5293 18.1458H24.5087L23.333 14.29H22.2892L23.9807 19.0417L23.8899 19.3306C23.7373 19.8204 23.4897 20.0088 23.0483 20.0088C22.9699 20.0088 22.8173 20.0004 22.7554 19.992V20.7749C22.8131 20.7916 23.0607 20.8 23.1349 20.8Z"
          fill="white"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_148973">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
